<template>
  <div class="hb-device" :class="`hb-device--${variant}`">
    <div v-if="variant === 'mobile'" class="hb-device__notch"></div>
    <div v-else class="hb-device__browserbar">
      <span class="hb-device__dot hb-device__dot--red"></span>
      <span class="hb-device__dot hb-device__dot--yellow"></span>
      <span class="hb-device__dot hb-device__dot--green"></span>
      <span class="hb-device__url">{{ siteUrl }}</span>
    </div>
    <div class="hb-device__viewport">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceFrame',
  props: {
    variant: { type: String, default: 'mobile' }, // 'mobile' | 'desktop'
    siteUrl: { type: String, default: '' },
  },
};
</script>

<style scoped>
.hb-device {
  background: #111827;
  border-radius: 28px;
  padding: 10px;
  box-shadow: 0 20px 45px rgba(17, 24, 39, 0.18);
  margin: 0 auto;
}
.hb-device--mobile {
  width: 375px;
  max-width: 100%;
}
.hb-device--desktop {
  width: 100%;
  border-radius: 12px;
  padding: 0;
  background: #e5e7eb;
}
.hb-device__notch {
  position: absolute;
  width: 120px;
  height: 22px;
  background: #111827;
  border-radius: 0 0 14px 14px;
  left: 50%;
  transform: translateX(-50%);
  margin-top: -2px;
  z-index: 1;
}
.hb-device--mobile { position: relative; }
.hb-device__browserbar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #d1d5db;
  border-radius: 12px 12px 0 0;
}
.hb-device__dot { width: 10px; height: 10px; border-radius: 50%; display: inline-block; }
.hb-device__dot--red { background: #ef4444; }
.hb-device__dot--yellow { background: #f59e0b; }
.hb-device__dot--green { background: #22c55e; }
.hb-device__url {
  margin-inline-start: 12px;
  font-size: 0.78rem;
  color: #4b5563;
  background: #fff;
  border-radius: 6px;
  padding: 2px 10px;
  flex: 1;
  direction: ltr;
  text-align: center;
}
.hb-device__viewport {
  background: #fff;
  overflow: hidden;
}
.hb-device--mobile .hb-device__viewport {
  border-radius: 20px;
  height: 720px;
}
.hb-device--desktop .hb-device__viewport {
  border-radius: 0 0 12px 12px;
  height: 640px;
}
</style>
